module.exports = __webpack_public_path__ + "static/media/club-tarjeta-caprabo.59fc15c0.png";